<template>
  <div>
	  <button @click.prevent="ConnectXero()">Connect to Xero</button> 
    <div>{{status}}</div>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import * as easing from 'eases/bounce-in'
import axios from 'axios'
const http = axios.create({
  withCredentials: false,
  crossdomain: true
})
export default {
  name: 'Setup',
  props: {
  },
  data () {
    return {
      status: ''
    }
  },
  methods: {
    ConnectXero: function () {
      
      var self = this;
      http.post(envConfig.API, JSON.stringify({"a":"SetupOAuth"}), {withCredentials: false,  crossdomain: true }).then(ret => {
        var url = ret.data.url;
        window.location.href = url;
      }).catch(function (e) {
        debugger
        self.status = e;
      })
    }
  },
  mounted() {
  },
  created: function () {


  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>





